import { Downloader } from '../interfaces/downloader.interface';
import { html, render, TemplateResult } from 'lit';

export class PdfDownloader implements Downloader {
  /**
   * The name of the file to be downloaded.
   */
  private readonly fileName: string;

  /**
   * @param filename
   */
  constructor(filename: string) {
    this.fileName = filename;
  }

  /**
   * Downloads a PDF file.
   *
   * @param headers
   * @param rows
   */
  download(headers: TemplateResult[], rows: TemplateResult[][]): void {
    const iframe: HTMLIFrameElement = this.getDownloadIframe();

    document.body.appendChild(iframe);

    setTimeout((): void => {
      this.renderIframeContent(iframe, headers, rows);
      setTimeout(this.printIframe.bind(this, iframe), 500);
    }, 500);
  }

  /**
   * Creates an iframe element for PDF download.
   */
  private getDownloadIframe(): HTMLIFrameElement {
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    iframe.src = '';
    iframe.title = document.title;
    iframe.width = '0';
    iframe.height = '0';

    return iframe;
  }

  /**
   * Prints the iframe content as PDF.
   */
  private printIframe(iframe: HTMLIFrameElement): void {
    if (!iframe?.contentWindow) {
      return;
    }

    const tmpTitle: string = document.title;

    iframe.contentWindow.document.title = this.fileName;
    document.title = this.fileName;
    iframe.contentWindow.print();
    document.title = tmpTitle;

    setTimeout((): void => {
      document.body.removeChild(iframe);
    }, 500);
  }

  /**
   * Renders the content of the iframe from lit templates.
   *
   * @param iframe
   * @param headers
   * @param rows
   */
  private renderIframeContent(
    iframe: HTMLIFrameElement,
    headers: TemplateResult[],
    rows: TemplateResult[][]
  ): void {
    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
      console.error('Could not download PDF');
      return;
    }

    for (const header of headers) {
      render(html`${header}`, iframe.contentDocument.head);
    }

    for (const row of rows) {
      for (const cell of row) {
        render(html`${cell}`, iframe.contentDocument.body);
      }
    }
  }
}
